import React, { ReactNode } from "react";
import { ThemeProvider as EmotionThemeProvider, Theme } from "@emotion/react";
import { compassColors } from "./utils/styling";
import { isCalorieClinicalRoute } from "./utils/userSegment";

const defaultTheme: Theme = {
  themeName: "DEFAULT",
  button: {
    primary: {
      enabled: {
        background: compassColors.tarocco,
      },
      hover: {
        background: compassColors.cinnamon,
      },
      focus: {
        background: compassColors.cinnamon,
      },
      borderRadius: "4px",
    },
    medPrimary: {
      enabled: {
        background: compassColors.lagoon,
      },
    },
    secondary: {
      borderRadius: "4px",
    },
  },
  progressBar: {
    background: compassColors.lagoon,
  },
  pageBackground: {
    background1: compassColors.blueberry,
  },
};

const calorieTheme: Theme = {
  themeName: "CALORIE",
  button: {
    primary: {
      enabled: {
        background: compassColors.black,
      },
      hover: {
        background: compassColors.grey4,
      },
      focus: {
        background: compassColors.tarocco,
      },
      borderRadius: "56px",
    },
    medPrimary: {
      enabled: {
        background: compassColors.black,
      },
    },
    secondary: {
      borderRadius: "56px",
    },
  },
  progressBar: {
    background: compassColors.black,
  },
  pageBackground: {
    background1: compassColors.black,
  },
};

interface ThemeProviderProps {
  children: ReactNode;
}

/* Theme provider wrapper for the buyflow, see https://emotion.sh/docs/theming for examples on how to use */
export function ThemeProvider({ children }: ThemeProviderProps) {
  let theme = defaultTheme;
  if (isCalorieClinicalRoute()) {
    theme = calorieTheme;
  }

  return <EmotionThemeProvider theme={theme}>{children}</EmotionThemeProvider>;
}
